import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import ParentNavPoint from './ParentNavPoint';

import './GlobalSidebar.scss';

/** Describe the component */

const GlobalSidebar = props => {
  const {
    closeSidebar,

    isOpen,
    links,
    loading,
    openSidebar,
  } = props;

  return (
    <>
      <nav
        aria-expanded={isOpen}
        className={classnames('global-sidebar', { loading })}
        role="navigation"
      >
        <CSSTransition
          classNames="fade-right"
          in={loading}
          timeout={200}
          unmountOnExit
        >
          <div className="loading-ui" />
        </CSSTransition>
        <hr />
        {links.map((navPoint, i) =>
          navPoint.type
            ? {
                externalLink: (
                  <a
                    className="nav-point"
                    href={navPoint.url}
                    // eslint-disable-next-line react/no-array-index-key
                    key={`nav-point-${i}`}
                    rel="noreferrer noopener"
                    target="_blank"
                  >
                    {navPoint.icon && (
                      <div className="icon">{navPoint.icon}</div>
                    )}
                    <div className="nav-point-title">{navPoint.name}</div>
                  </a>
                ),
                parent: (
                  <ParentNavPoint
                    // eslint-disable-next-line react/no-array-index-key
                    key={`nav-point-${i}`}
                    closeSidebar={closeSidebar}
                    navPoint={navPoint}
                    openSidebar={openSidebar}
                    sidebarIsOpen={isOpen}
                  />
                ),
                // eslint-disable-next-line react/no-array-index-key
                separator: <hr key={`nav-point-${i}`} />,
              }[navPoint.type]
            : navPoint.url && (
                <Link
                  className={classnames('nav-point', {
                    current: navPoint.current,
                  })}
                  // eslint-disable-next-line react/no-array-index-key
                  key={`nav-point-${i}`}
                  onClick={closeSidebar}
                  to={navPoint.url}
                >
                  {navPoint.icon && <div className="icon">{navPoint.icon}</div>}
                  <div className="nav-point-title">{navPoint.name}</div>
                </Link>
              )
        )}
      </nav>
      <CSSTransition classNames="fade" in={isOpen} timeout={200} unmountOnExit>
        <button
          aria-label="Close Navigation"
          className="sidebar-overlay"
          onClick={closeSidebar}
          type="button"
        />
      </CSSTransition>
    </>
  );
};

GlobalSidebar.propTypes = {
  /** Function to force the sidebar closed (for the overlay button) */
  closeSidebar: PropTypes.func,
  /** Is the sidebar open (mostly for phones & tablets, always true on desktop) */
  isOpen: PropTypes.bool,
  /** Show sidebar loading staet */
  loading: PropTypes.bool,
  /** Links array containing all nav points */
  links: PropTypes.arrayOf(
    PropTypes.shape({
      current: PropTypes.bool,
      icon: PropTypes.node,
      url: PropTypes.string,
      name: PropTypes.node,
      type: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          current: PropTypes.bool,
          url: PropTypes.string,
          name: PropTypes.node,
        })
      ),
    })
  ),
  /** Function to force the sidebar open (useful when expanding a parent nav point on tablet) */
  openSidebar: PropTypes.func,
};

GlobalSidebar.defaultProps = {
  closeSidebar: null,

  isOpen: false, // not sure what the right default is, probably doesn't matter
  links: [],
  loading: false,
  openSidebar: null,
};

export default GlobalSidebar;
